"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KdmMeeting = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const meeting_entity_1 = require("./meeting.entity");
let KdmMeeting = class KdmMeeting {
    constructor(meetingId, remarks, mom, statusLid, kdmMeetingTypeLid, selectMeeting, opportunityId, activityId) {
        this.meetingId = meetingId;
        this.remarks = remarks;
        this.mom = mom;
        this.statusLid = statusLid;
        this.kdmMeetingTypeLid = kdmMeetingTypeLid;
        this.selectMeeting = selectMeeting;
        this.opportunityId = opportunityId;
        this.activityId = activityId;
    }
};
exports.KdmMeeting = KdmMeeting;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "meetingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], KdmMeeting.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mom", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], KdmMeeting.prototype, "mom", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "kdm_meeting_type_lid", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "kdmMeetingTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "select_meeting_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], KdmMeeting.prototype, "selectMeeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], KdmMeeting.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], KdmMeeting.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], KdmMeeting.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], KdmMeeting.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => meeting_entity_1.Meeting),
    (0, typeorm_1.JoinColumn)({ name: "meeting_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof meeting_entity_1.Meeting !== "undefined" && meeting_entity_1.Meeting) === "function" ? _d : Object)
], KdmMeeting.prototype, "meeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _e : Object)
], KdmMeeting.prototype, "status", void 0);
exports.KdmMeeting = KdmMeeting = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_kdm_meeting" }),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, Number, Number, Object, Number, Number])
], KdmMeeting);
